export default __webpack_public_path__ + "static/media/Acknowledge.22a10946.mov";